<script setup lang="ts">
import { ref } from "vue";
import Pop from "./Pop.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Pop },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    tel: string;
  }>(),
  {}
);

const emits = defineEmits<{
  (event: "open"): void;
  (event: "close"): void;
}>();

const el = ref();

function open() {
  el.value?.open();
}
function close() {
  el.value?.close();
}

defineExpose({ open, close });
</script>

<template>
  <Pop
    ref="el"
    directionFrom="bottom"
    :closeWhenClickOverlay="false"
    @open="() => emits('open')"
    @close="() => emits('close')"
  >
    <div class="pop-tel">
      <div>{{ tel }}</div>
      <a
        class="pop-tel-call"
        :href="`tel:${tel}`"
        @click="close"
      >
        呼叫
      </a>
      <div
        class="pop-tel-cancel"
        @click="close"
      >
        取消
      </div>
    </div>
  </Pop>
</template>

<style scoped>
.pop-tel {
  background-color: #ffffff;
  color: #333333;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.pop-tel > div,
.pop-tel-call {
  display: block;
  height: 64px;
  line-height: 64px;
  font-size: 18px;
  text-align: center;
}
.pop-tel-cancel,
.pop-tel-call {
  border-top: 1px solid #e6e6e6;
}
.pop-tel > div:nth-child(1) {
  color: #999999;
}
.pop-tel-call {
  color: #333333;
  font-weight: bold;
}
.pop-tel-call,
.pop-tel-call:link,
.pop-tel-call:visited,
.pop-tel-call:hover,
.pop-tel-call:active {
  /* 禁止长按链接与图片弹出菜单 */
  -webkit-touch-callout: none;
  text-decoration: none;
}
.pop-tel-call:focus {
  outline: none;
}
</style>
